import dayjs from "dayjs";
import { formatTimestampForTable } from "./dateDisplay";
import { getPhotographyConsentSortKey } from "./photographyConsent";

export function getParticipantRegisteredAtCell(participant) {
  return formatTimestampForTable(participant?.registration_date);
}

export function getParticipantRegTypeCell(participant, event) {
  const existing = (participant?.registration_type != null ? String(participant.registration_type) : "").trim();
  if (existing) return existing;
  const reg = participant?.registration_date;
  const start = event?.start_datetime;
  if (!reg || !start) return "";
  const regD = dayjs(reg);
  const startD = dayjs(start);
  if (!regD.isValid() || !startD.isValid()) return "";
  const dayDiff = startD.startOf("day").diff(regD.startOf("day"), "day");
  if (dayDiff >= 1) return "Registered";
  if (dayDiff === 0) return "Walk-In";
  return "";
}

export function getParticipantNameForSort(p) {
  return [p?.last_name, p?.first_name].filter(Boolean).join(", ").trim();
}

export function buildParticipantSortRow(p) {
  const participant_name = getParticipantNameForSort(p);
  return {
    ...p,
    participant_name,
    registered_at: p?.registration_date || null,
    photo_consent_sort: getPhotographyConsentSortKey(p?.photography_consent),
  };
}
